<template>
  <div class="mt-4">
    <div class="recommendation-step">
      <div class="form-group">
        <label for="">Recommendation</label>
        <multiselect
          v-model="recommendation.recommendation"
          :options="recommendations"
          :allow-empty="false"
          :show-labels="false"
          :searchable="false"
          :class="{ 'is-invalid': !!errors.recommendation_id }"
          placeholder="Select recommendation"
          style="cursor:pointer"
          select-label="Select"
          label="name"
          track-by="id"
          @select="(o) => recommendation.recommendation_id = o.id"
        >
          <span
            slot="placeholder"
            class="mutliselect__placeholder"
          >
            Select recommendation
          </span>
        </multiselect>
      </div>

      <div class="form-group">
        <label for="">Target Price</label>
        <t-input
          :class="{ 'el-input--invalid': !!errors.target_price }"
          placeholder="Target Price"
          v-model="recommendation.target_price"
        />

        <multiselect
          v-if="currencies"
          v-model="recommendation.currency"
          :options="currencies"
          :allow-empty="false"
          :show-labels="false"
          :searchable="true"
          :class="{ 'is-invalid': !!errors.target_price_currency_id }"
          placeholder="Currency"
          class="mt-2 currency-multiselect"
          style="cursor:pointer"
          select-label="Select"
          label="code"
          track-by="id"
          @select="(o) => recommendation.target_price_currency_id = o.id"
        >
          <template
            slot="option"
            slot-scope="props"
          >
            {{ props.option.symbol }} - {{ props.option.code }}
          </template>
        </multiselect>
      </div>
    </div>


    <div class="w-100 mt-4 py-4 d-flex border-top">
      <button
        @click="createRecommendation"
        class="ml-auto btn btn-primary "
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import {successNotification} from '@/notifications'
import Date from '@/directives/date'

export default {
  props: {
    company: {
      required: true,
      type: Object,
    },
  },
  directives: {
    Date,
  },
  data () {
    const r = this.company.latest_approved_recommendation
    return {
      currencies: [],
      errors: {},
      recommendation: {
        investment_thesis: r ? r.investment_thesis : null,
        risk_to_thesis: r ? r.risk_to_thesis : null,
        valuation: r ? r.valuation : null,
        bottom_line: r ? r.bottom_line : null,
        recommendation: r ? r.recommendation : null,
        recommendation_id: r ? r.recommendation.id : null,
        target_price: r ? r.target_price : null,
        currency: r && r.currency ? r.currency : null,
        target_price_currency_id: r && r.currency ? r.currency.id : null,
      },
      recommendations: [],
    }
  },
  async mounted () {
    const [recommendations, currencies] = await Promise.all([
      this.$http.get('recommendations'),
      this.$http.get('currencies'),
    ])
    this.recommendations = recommendations.data.data
    this.currencies = currencies.data.data
  },

  methods: {


    onPdfUpload () {
      // TODO:
    },

    onPdfRemove () {
      // TODO:
    },

    onModelUpload () {
      // TODO:
    },

    onModelRemove () {
      // TODO:
    },

    async createRecommendation () {
      try {
        const {data} = await this.$http.post(`companies/${this.company.id}/recommendations`, this.recommendation)
        this.$notify(successNotification('Saved our view!'))
        this.company.latest_approved_recommendation = data.data
      } catch (e) {
        this.errors = e.response.data.errors
      }
    },

  },
}
</script>

<style lang="scss">
.recommendation-step {
}
</style>
